import { __decorate } from "tslib";
import { __metadata } from "tslib";
import { Component, ContentChildren, QueryList } from '@angular/core';
import { RoamingStepperItemComponent } from './roaming-stepper-item';
var RoamingStepperComponent = /*@__PURE__*/ (function () {
    /**
     * TypeScript public modifiers
     */
    function RoamingStepperComponent() {
        /**
         * Set our default values
         */
        this.localState = { value: '' };
    }
    RoamingStepperComponent.prototype.ngAfterContentInit = function () {
    };
    RoamingStepperComponent.prototype.openItem = function (item) {
    };
    return RoamingStepperComponent;
}());
export { RoamingStepperComponent };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/app/shared/components/roaming-stepper/roaming-stepper.component.ts
// module id = null
// module chunks = 